const MuiAvatarOverrides = {
  MuiAvatar: {
    styleOverrides: {
      root: ({
        theme
      }) => ({
        fontSize: theme.typography.body01.fontSize,
        fontWeight: 'normal'
      }),
      square: ({
        theme
      }) => ({
        color: theme.palette.gray80,
        fontWeight: 'bold'
      })
    }
  }
};

export { MuiAvatarOverrides };
